// extracted by mini-css-extract-plugin
export var button = "styles-module--button--DcHQo";
export var buttons = "styles-module--buttons--UBwhK";
export var schemaLabel = "styles-module--schemaLabel--8GnwZ";